import { useRef } from "react";
import { motion, useScroll, useTransform } from "framer-motion";
import { Reveal, MaskLine } from "@/components/Reveal";
import { IMAGES } from "@/lib/data";

export const PageHero = ({ overline, titleLines, description, image }) => {
    const ref = useRef(null);
    const { scrollYProgress } = useScroll({ target: ref, offset: ["start start", "end start"] });
    const y = useTransform(scrollYProgress, [0, 1], ["0%", "22%"]);

    return (
        <section ref={ref} className="relative min-h-[62vh] flex items-end overflow-hidden pt-32 pb-16" data-testid={`page-hero-${overline.toLowerCase().replace(/[^a-z0-9]+/g, "-")}`}>
            <motion.div style={{ y }} className="absolute inset-0 -z-10">
                <img src={IMAGES[image] || IMAGES.factory} alt="" className="w-full h-[125%] object-cover opacity-40" />
                <div className="absolute inset-0 bg-gradient-to-t from-sf-black via-sf-black/60 to-sf-black/30" />
            </motion.div>
            <div className="sf-container w-full">
                <Reveal>
                    <p className="sf-overline">{overline}</p>
                </Reveal>
                <h1 className="font-display font-extrabold text-5xl sm:text-6xl lg:text-8xl leading-[0.92] tracking-tight text-white mt-6">
                    {titleLines.map((line, i) => (
                        <MaskLine key={i} delay={0.15 + i * 0.12}>
                            {line}
                        </MaskLine>
                    ))}
                </h1>
                {description && (
                    <Reveal delay={0.4}>
                        <p className="text-sf-silver text-base md:text-lg leading-relaxed mt-8 max-w-2xl">{description}</p>
                    </Reveal>
                )}
            </div>
        </section>
    );
};
